import { createMD5 } from 'hash-wasm'

/**
 * Create md5 hash from string
 * @param str String to hash
 */
export async function md5(str: string) {
  const md5Hasher = await createMD5()
  md5Hasher.init()
  md5Hasher.update(str)
  return md5Hasher.digest('hex')
}
